/*
  assets/nz-price-gate.js
  Swaps "POA – Enquire" (rendered by snippets/price.liquid for nz-price-only
  products) for the real price, only when BOTH checks pass:
    1. Browser time zone is Pacific/Auckland or Pacific/Chatham (checked here)
    2. Shopify put the request in the NZ market and the product has a price
       above $0 (checked server-side by templates/product.accuphase-price.liquid)
  Fails closed: any error, empty response or unexpected markup leaves POA.
*/
(function () {
  var tz = '';
  try { tz = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (e) { return; }
  if (['Pacific/Auckland', 'Pacific/Chatham'].indexOf(tz) === -1) return;

  var cache = {};

  function load(el) {
    if (el.dataset.nzState) return;
    var base = el.dataset.productUrl;
    if (!base) return;
    el.dataset.nzState = 'loading';

    var url = base + '?view=accuphase-price';
    var variant = new URLSearchParams(location.search).get('variant');
    if (el.dataset.useVariant === 'true' && variant) url += '&variant=' + encodeURIComponent(variant);

    cache[url] = cache[url] || fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .catch(function () { return ''; });

    cache[url].then(function (html) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html || '';
      var ok = tmp.querySelector('[data-nz-price-ok]');
      var price = ok && ok.querySelector('.f-price');
      if (!price) { el.dataset.nzState = 'none'; return; }

      // Keep the slot's sizing/alignment classes (large on product pages, card alignment, etc.)
      var poa = el.querySelector('.f-price');
      if (poa) {
        poa.classList.forEach(function (c) {
          if (c !== 'f-price--poa') price.classList.add(c);
        });
      }
      el.innerHTML = '';
      el.appendChild(price);
      el.dataset.nzState = 'done';
    });
  }

  function scan() {
    document.querySelectorAll('[data-nz-price]:not([data-nz-state])').forEach(load);
  }

  function start() {
    scan();
    new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
